import { z } from 'zod';
import { addressZipPlus4ValidationSchema } from './shared/address';
export const companyValidationSchema = z.object({
    name: z.string().min(1, 'Required'),
    taxId: z.string().length(9, 'Must be 9 digits'),
    npi: z.string().length(10, 'Must be 10 digits'),
    ptan: z.string().length(6, 'Must be 6 digits'),
    agencyId: z.string().optional(),
    accreditationBody: z.string().nullish(),
    accreditationId: z.string().nullish(),
    address: addressZipPlus4ValidationSchema,
    services: z
        .object({
        homeHealth: z.boolean(),
        homeHealthServices: z.object({
            SN: z.boolean(),
            PT: z.boolean(),
            OT: z.boolean(),
            ST: z.boolean(),
            MSW: z.boolean(),
            HHA: z.boolean(),
        }),
        pca: z.boolean(),
        hospice: z.boolean(),
    })
        .refine(({ homeHealth, pca, hospice }) => homeHealth || pca || hospice, {
        message: 'Requires at least one service',
        path: [],
    }),
});
